/**
 * Разбор и вывод значений legacy-БД. Все квирки в одном месте.
 */

import type { PgBool } from '@/api/types'

/** Булево из PostgreSQL через legacy-код: 't'/'f' или настоящий boolean. */
export function isTrue(value: PgBool | string | number | null | undefined): boolean {
  return value === true || value === 't' || value === '1' || value === 1 || value === 'true'
}

/** Деньги/показания хранятся текстом с запятой: «1 234,56» → 1234.56. */
export function toNumber(value: string | number | null | undefined): number {
  if (typeof value === 'number') return value
  if (value === null || value === undefined || value === '') return 0
  const normalized = value.replace(/\s/g, '').replace(',', '.')
  const parsed = Number.parseFloat(normalized)
  return Number.isNaN(parsed) ? 0 : parsed
}

/** Формат денег как в legacy: number_format($v, 2, ',', ' ') → «1 234,56». */
export function formatMoney(value: string | number | null | undefined): string {
  return toNumber(value)
    .toFixed(2)
    .replace('.', ',')
    .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}

/** «2024-03-15 12:00:00» → «15.03.2024». */
export function formatDate(value: string | null | undefined): string {
  if (!value) return ''
  const [datePart] = value.split(' ')
  const [year, month, day] = datePart.split('-')
  if (!year || !month || !day) return value
  return `${day}.${month}.${year}`
}

/** 'YYYYMM' → «Март 2024». */
export function formatMonthNumber(monthNumber: string | null | undefined): string {
  if (!monthNumber || monthNumber.length !== 6) return monthNumber ?? ''
  const months = [
    'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
    'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь',
  ]
  const year = monthNumber.slice(0, 4)
  const monthIndex = Number.parseInt(monthNumber.slice(4), 10) - 1
  return `${months[monthIndex] ?? monthNumber.slice(4)} ${year}`
}

/** Подписи типов начислений (как в legacy-интерфейсе). */
export const INVOICE_TYPE_LABEL: Record<string, string> = {
  electro: 'Электроэнергия',
  chlenskie: 'Членский взнос',
  celevie: 'Целевой взнос',
  other: 'Прочее',
}
